import Vue from "vue";
import {Component} from "vue-property-decorator";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import {AXIOS} from "@/lib/http-common";

@Component
export default class ImportItems extends Vue {

  public openImportItemsDialogOpened: boolean = false;
  public selectedFile: File | null = null;
  public fileError: string = "";
  public isFileValid: boolean = false;

  public mounted() {
    this.openImportItemsDialog();
  }

  public openImportItemsDialog() {
    this.openImportItemsDialogOpened = true;
  }

  public closeImportItemsDialog() {
    this.openImportItemsDialogOpened = false;
    this.selectedFile = null;
    this.fileError = "";
    this.isFileValid = false;
    this.$router.push('/');
  }

  public async importItems() {
    if (!this.selectedFile) {
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    AXIOS.post('/item/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(value => {
      if (value.status !== 200) {
        UserActionResultSender.showErrorFeedback('items.import.error');
        return;
      }
      UserActionResultSender.showSuccessFeedback('items.import.success');
    })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback('items.import.error');
      })
      .finally(() => {
        this.openImportItemsDialogOpened = false;
        this.$router.push('/items');
      });
  }

  public validateFile() {
    if (this.selectedFile) {
      const fileType = this.selectedFile.type;
      const fileName = this.selectedFile.name;

      if (!fileName.endsWith(".csv")) {
        this.fileError = "Only .csv files are allowed.";
        this.isFileValid = false;
      } else {
        this.fileError = "";
        this.isFileValid = true;
      }
    } else {
      this.fileError = "Please select a CSV file.";
      this.isFileValid = false;
    }
  }
}
